module.exports = __webpack_public_path__ + "static/media/us-land-shop-contact-bg.976a1475.jpg";